import React, { useState } from "react";
import { Box, Button, Text, Heading } from "grommet";
import { Sliders } from "../../components/sliders/sliders";
import { Switch, CircularProgress } from "@material-ui/core";
import { LeadLabels } from "../../components/lead-labels";
import { PlotECG } from "../plot-ecg";

const SIGNIFICANT_DIMENSIONS = [1, 5, 6, 8, 9, 10, 11, 12, 13, 15, 16, 17, 19, 22, 23, 25, 26, 27, 30, 31, 32];

export function Main({ ecg, originalEcg, sliders, isModelLoaded, progress, onResetSliders, onSliderChange }: any): React.ReactElement {
  const [showInsignificants, setShowInsignificants] = useState<boolean>(false);

  const toggleShowInsignificants = () => {
    setShowInsignificants((prev) => !prev);
  };

  return (
    <Box gridArea="main" gap="60px">
      <Box direction="column" justify="between" gap="small">
        <Box direction="row" gap="medium" justify="between" align="center" width="100%">
          <Box direction="row" align="center" width="230px">
            <Switch checked={showInsignificants} onChange={toggleShowInsignificants} />
            <Text size="small">Show insignificant dimensions</Text>
          </Box>
          <Heading level={3}>FactorECG</Heading>
          <Box width="230px" align="end">
            <Button label="Reset dimensions" size="small" onClick={onResetSliders} />
          </Box>
        </Box>
        <Sliders
          showInsignificants={showInsignificants}
          sliders={sliders}
          handleSliderChange={onSliderChange}
          isModelLoaded={isModelLoaded}
          significantDimensions={SIGNIFICANT_DIMENSIONS}
        />
      </Box>
      {isModelLoaded ? (
        <Box fill style={{ position: "relative" }}>
          {originalEcg && (
            <div style={{ position: "absolute", width: "100%", height: "100%" }}>
              <LeadLabels />
              <PlotECG ecg={originalEcg} original={true} />
            </div>
          )}
          {ecg && (
            <div style={{ position: "absolute", width: "100%", height: "100%" }}>
              <PlotECG ecg={ecg} original={false} />
            </div>
          )}
        </Box>
      ) : (
        <Box pad="medium" align="center">
          <CircularProgress variant="determinate" value={progress} />
          <Box pad="small">
            <Text>Loading model...</Text>
          </Box>
        </Box>
      )}
    </Box>
  );
}
